import { RootState } from 'redux/schemas';
import { createSelector } from 'reselect';
import { indexBy, pluck } from 'underscore';

export const getCollections = (state: RootState) => {
  const courses = Object.values(state.models.courses);
  return courses.filter((course) => course.isContentManagementCollection);
};

export const getCollectionCatalogIds = (state: RootState): string[] => pluck(getCollections(state), 'catalogId');

export const getCollectionsHasFolders = (state: RootState) => {
  const collections = Object.values(getCollections(state));

  return collections.filter((collection) => collection.foldersCount > 0);
};

export const getCollectionFolder = (state: RootState, folderId: number) => state.models.collectionFolders?.[folderId];

export const getCollectionFolderLecturePages = createSelector(
  [
    (state: RootState, folderId: number) => state.models.collectionFolders?.[folderId].lecturePages,
    state => state.models.lecturePages,
  ],
  (folderLecturePages, lecturePages) => indexBy(folderLecturePages?.map(lecturePageId => lecturePages[lecturePageId]), 'id'),
);

export const getLinkedCourses = (state: RootState, lecturePageId: number) => {
  const lecturePage = state.models.lecturePages[lecturePageId];

  return lecturePage?.contentManagementLinks
    ? lecturePage?.contentManagementLinks.map((link) => ({
      courseId: link.course.id,
      courseName: link.course.name,
      courseCatalogId: link.course.catalogId,
      linkedLecturePageId: link.targetId,
    }))
    : [];
};


export const getBulkConvertibleLecturePagesData = (state: RootState, courseId: number) => (
  state.app.collection.bulkConvertibleLecturePages?.[courseId]
);

export const getConvertibleLecturePageCounts = createSelector(
  [getBulkConvertibleLecturePagesData],
  (result) => {
    const sectionConvertibleLectureCounts: Record<number, number> = {};
    const subsectionConvertibleLectureCounts: Record<number, number> = {};

    if (!result) {
      return {
        courseConvertibleLecturePagesCount: 0,
        sectionConvertibleLectureCounts,
        subsectionConvertibleLectureCounts,
      };
    }

    (result.lectureSections)?.forEach((section) => {
      sectionConvertibleLectureCounts[section.id] = section.convertibleLecturePagesCount ?? 0;
      (section.lectureSubsections)?.forEach((subsection) => {
        subsectionConvertibleLectureCounts[subsection.id] = subsection.convertibleLecturePagesCount ?? 0;
      });
    });

    (result.lectureSubsections)?.forEach((subsection) => {
      subsectionConvertibleLectureCounts[subsection.id] = subsection.convertibleLecturePagesCount ?? 0;
    });

    return {
      courseConvertibleLecturePagesCount: result.convertibleLecturePagesCount ?? 0,
      sectionConvertibleLectureCounts,
      subsectionConvertibleLectureCounts,
    };
  },
);

